import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./../consultaNominas/consultaNominas.scss";
import { memo } from "react";
import React from "react";


registerLocale("es", es);

const ModalDetalleAdicional = (object) => {
  
  function modalDetalleAdicional() {
    return (
      <Modal
        className={`infModal"
          } `}
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Datos Adicionales"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Datos Adicionales</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 p-3">
            <div className="tablaDatos">
            {object?.detalle?.map((item, index) => (
                <div key={index}>
                    <h5>{item.NOMBRE}</h5>
                    <p>{item.VALOR} {item.DESCRIPCION !== null && item.DESCRIPCION !== "" ? (<>- {item.DESCRIPCION}</>) : null}</p>
                    <hr />
                </div>
            ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalDetalleAdicional()}</>;
};

export default memo(ModalDetalleAdicional);